@if (isMenu) {
  <button mat-menu-item [attr.aria-label]="'groups' | translate">
    <div class="item-menu-center">
      <span class="material-symbols-outlined"> group </span>
      <span>{{ 'groups' | translate }}</span>
    </div>
  </button>
} @else {
  <button
    mat-icon-button
    [attr.aria-label]="'groups' | translate"
    matTooltip="{{ 'groups' | translate }}">
    <span class="material-symbols-outlined"> group </span>
  </button>
}
